<template>
  <ul>
    <!-- TODO: =(==> Adaptive: create modal <==(= -->
    <template v-if="list">
      <transition-group name="slide-fade">
        <li v-for="(item, idx) in list" :key="idx">
          <span>{{ item.name }}</span>
          <span class="between">{{ calcDots(item) }}</span>
          <span class="price-wrap">
            <span class="old_price" v-if="item.old_price">
              {{ item.old_price }} Р
            </span>
            <span class="new_price" v-if="item.new_price">
              <span class="fw600">
                {{ item.new_price }}
              </span>
                Р/час
            </span>
            <span class="price" v-if="item.price">
              <span class="fw600">
                {{ item.price }} Р
              </span>
                <a href="#" v-if="!hide" @click.prevent="$emit('delete', item, idx)">
                  <img src="@/assets/images/icons/trash.svg" alt="">
                </a>
            </span>
          </span>
        </li>
      </transition-group>
    </template>
    <template v-else>
      <div v-if="hide" style="padding-top: 10px;padding-bottom: 10px; display: flex; justify-content: center;">
        <h4>Цены не указаны</h4>
      </div>
    </template>
    <div class="add" v-if="!hide">
      <button v-if="isHidden" @click="isHidden = !isHidden">Добавить услугу</button>
      <div class="add__items" v-if="!isHidden" style="flex-wrap: nowrap">
        <div style="display: flex;flex-direction: column;width: 100%;">
          <input placeholder="Наименование" class="name" type="text" v-model="item.name">
          <error-text :text="errors.name"/>
        </div>
        <div style="display: flex;flex-direction: column;">
          <input placeholder="Цена" class="price" type="text" v-model="item.price">
          <error-text :text="errors.price"/>
        </div>
        <button @click="addItem()"><img src="@/assets/images/icons/chevron-down.svg" alt=""></button>
      </div>
    </div>
  </ul>
</template>

<script>
import ErrorText from '../../../../components/ui/text/error-text'

export default {
  name: 'PriceList',
  components: {ErrorText},
  props: {
    list: Array,
    errors: Object,
    perHour: Boolean,
    hide: Boolean,
    id: String,
    specialization: Number
  },
  mounted() {
    this.$eventHub.$on('price.created', () => this.isHidden = true)
  },
  methods: {
    addItem() {
      this.$emit('addItem', this.item, this.specialization)
    },
    calcDots(item) {
      let words = 0
      words += item.name.length
      if (item.old_price) {
        words += item.old_price.toString().length
        /* _Р_*/
        words += 2
      }
      if (item.new_price) {
        words += item.old_price.toString().length
      }
      if (item.price) {
        words += item.price.toString().length
      }
      if (this.perHour) {
        words += 5
      }
      /*_Р/час */
      words += 6
      const dots_count = 40 - words
      const dotsArray = []
      for (let i = 0; i < dots_count; i++) {
        dotsArray.push('. ')
      }
      return dotsArray.join('')
    }
  },
  data: () => ({
    isHidden: true,
    item: {
      name: null,
      price: null
    }
  }),
  beforeDestroy() {
    this.$eventHub.$off('price.created')
  }
}
</script>

<style scoped lang="scss">
.title {
  padding-top: -20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.4;
  }

  button {
    border: none;
    background-color: transparent;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    text-align: right;
    color: #B9765B;
  }
}

.add {
  display: flex;
  flex-wrap: wrap;

  button {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    color: #B9765B;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 0;

    &:before {
      content: '';
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background-image: url("../../../../assets/images/icons/edit.svg");
      background-position: center center;
      background-size: contain;
    }
  }

  &__items {
    display: flex;
    flex-wrap: wrap;

    button {

      width: 15%;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0 0;

      img {
        height: 30px;
        width: 50px;
      }

      &:before {
        content: '';
        width: 0px;
        height: 0px;
        margin-right: 5px;
        background-image: none;
        background-position: center center;
        background-size: contain;
      }
    }

    input {
      height: 37.5px;
      background: #FFFFFF;
      border: 1px solid #DBBFA7;
      border-radius: 5px;
      padding-left: 20px;
      color: #383838;
      font-size: 16px;

      &::placeholder {
        font-size: 16px;
        line-height: 24px;
        color: #808080;
      }

      &.name {
        width: 100%;
      }

      &.price {
        width: 100%;
      }
    }
  }

}


ul {
  list-style: none;
  padding-bottom: 0px;

  li {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 16px;
    line-height: 1.5;
    font-family: "Open Sans", sans-serif;

    .between {
      margin: 0 5px;
    }

    .price {
      text-align: right;
      color: #383838;
      display: flex;
      align-items: center;

      a {
        display: flex;
        align-items: center;
      }
    }
  }
}

.old_price {
  font-size: 16px;
  line-height: 1.5;
  color: #808080;
  text-decoration: line-through;
  margin-right: 5px;
}

.new_price {
  font-size: 16px;
  line-height: 1.5;
  color: #E05252;
}

.price {
  font-size: 16px;
  line-height: 1.5;
  color: #383838;
  margin-left: 5px;
}

.fw600 {
  font-weight: 600;

}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

@media screen and (max-width: 991px) {
  ul li .between {
    display: none;
  }
}
</style>
